import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SlotMachineContext } from "../../../context";
import { Notification } from "../../atoms";

const SlotMachineNotifications = () => {
    const { t } = useTranslation();
    const { isConfirmSelectionClicked } = useContext(SlotMachineContext);

    return (        
        <div>
            {isConfirmSelectionClicked && (
                <div className="slot_machine_warning noselect" style={{ width: "100vw" }}>
                    <div className="center_horizontally_and_vertically">
                        <Notification notificationMessage={t("waitForOthersToConfirmText")} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default SlotMachineNotifications;